import { render } from "./ShowDiff.vue?vue&type=template&id=324a0251&scoped=true"
import script from "./ShowDiff.vue?vue&type=script&lang=js"
export * from "./ShowDiff.vue?vue&type=script&lang=js"

import "./ShowDiff.vue?vue&type=style&index=0&id=324a0251&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-324a0251"]])

export default __exports__